// extracted by mini-css-extract-plugin
module.exports = {"performance":"LoadingIndicator_performance__S0ZPg","rotation":"LoadingIndicator_rotation__WVR2Z"};